<div class="px-3 bulk-accounting-dialog">
    <div class="row mb-3">
        <div class="col">
            <h6>
                <em class="fas fa-pen pe-2"></em>
                {{ 'Kontierungen bearbeiten' | translate }}
            </h6>
        </div>
        <div class="col-auto">
            <button mat-icon-button color="warn" (click)="cancel()">
                <em class="fas fa-times fa-1_5x"></em>
            </button>
        </div>
    </div>
    @if (accountingReloading()) {
        <div
            class="row mb-2 bulk-accounting-dialog__reloading"
            role="status"
            aria-live="polite"
            data-cy="BULK_ACCOUNTING_RELOADING"
        >
            <iim-spinner color="secondary" size="medium"></iim-spinner>
            <span>{{ 'Kontierung wird geprüft …' | translate }}</span>
        </div>
    }
    <div class="row mb-2" [class.d-none]="accountingReloading()">
        <div class="col">
            <accounting-selection-v2
                [values]="input"
                [costCenterEditable]="options.editCostCenter"
                [projectEditable]="options.editProject"
                [generalLedgerAccountEditable]="options.editGeneralLedgerAccount"
                [customAccountAssignmentEditable]="options.editCustomAccountAssignment"
                [companyCodeId]="options.companyCodeId ?? ''"
                (accountingChanged)="accountingChanged($event)"
            ></accounting-selection-v2>
        </div>
    </div>
    @if (!options.hideClassification) {
        <div class="row mb-2">
            <div class="col">
                <classification-selection
                    (classificationSelected)="classificationChanged($event)"
                ></classification-selection>
            </div>
        </div>
    }
    @if (!options.hideSite) {
        <div class="row mb-2">
            <div class="col">
                <lib-site-selection
                    [companyCodeId]="options.companyCodeId ?? ''"
                    [editable]="true"
                    (siteChanged)="siteChanged($event)"
                ></lib-site-selection>
            </div>
        </div>
    }
    @if (options.showPurchasingGroup) {
        <div class="row mb-2">
            <div class="col">
                <app-accounting-base
                    [label]="purchasingGroupLabel"
                    [accountingOptions]="purchasingGroupOptions()"
                    [isLoading]="loadingPurchasingGroups()"
                    [defaultToFirstOption]="false"
                    [allowClear]="true"
                    localFullSelection
                    (selectedOptionChange)="purchasingGroupSelected($event)"
                    (selectionCleared)="purchasingGroupCleared()"
                ></app-accounting-base>
            </div>
        </div>
    }
    @if (options.showMaterialGroup) {
        <div class="row mb-2">
            <div class="col">
                <material-group-selection
                    [editable]="true"
                    (valueChange)="materialGroupChanged($event)"
                ></material-group-selection>
            </div>
        </div>
    }
    @if (options.showPurchasingGroupPreview) {
        <div class="row mb-2">
            <div class="col">
                <app-accounting-base
                    data-cy="BULK_PURCHASING_GROUP_PREVIEW"
                    [label]="purchasingGroupLabel"
                    [placeholder]="purchasingGroupPreviewHint()"
                    [accountingOptions]="purchasingGroupPreviewOptions()"
                    [initialSelectedCode]="purchasingGroupPreview()?.code ?? null"
                    [display]="purchasingGroupPreviewDisplay"
                    [isLoading]="loadingPurchasingGroupPreview()"
                    [isReadonly]="true"
                    [isDisabled]="true"
                    [allowClear]="false"
                    [allowFullSelection]="false"
                    [defaultToFirstOption]="false"
                ></app-accounting-base>
            </div>
        </div>
    }
    <div class="row mb-2">
        <div class="col">
            <div class="bulk-accounting-dialog__hint" role="note" data-cy="BULK_ACCOUNTING_SCOPE_HINT">
                <em class="fas fa-info-circle pe-2" aria-hidden="true"></em>
                <span>{{ scopeHint | translate }}</span>
            </div>
        </div>
    </div>
    <div class="bulk-accounting-dialog__options border-top pt-3 mt-3 mb-0 pb-0">
        <p class="text-muted small pb-0 mb-0">
            {{ 'Optionen:' | translate }}
        </p>
        <div class="row">
            <div class="col-auto">
                <mat-slide-toggle
                    id="overwriteExisting"
                    [checked]="overwriteExisting"
                    (change)="overwriteExisting = $event.checked"
                    labelPosition="before"
                >
                    <div class="text-muted small">
                        {{ 'Vorhandene Kontierungen überschreiben' | translate }}
                    </div>
                </mat-slide-toggle>
            </div>
        </div>
        <div class="row justify-content-end mt-3">
            <div class="col-md-auto col-sm-12 mb-1">
                <button
                    class="btn btn-primary w-100 btn-sm"
                    data-cy="SAVE_ACCOUNTINGS"
                    (click)="select()"
                    [disabled]="!hasSelection()"
                >
                    {{ 'Auswählen' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
